import React, { useState } from "react"
import { Link } from "gatsby"
import scrollTo from "gatsby-plugin-smoothscroll"
export interface FunctionCortexBlockProps {}

const personDetection = require("../../images/icons-function/person-detection.svg") as string
const personTracking = require("../../images/icons-function/person-tracking.svg") as string
const faceDetection = require("../../images/icons-function/face-detection.svg") as string
const attentionDetection = require("../../images/icons-function/attention-detection.svg") as string
const emotionPrediction = require("../../images/icons-function/mask-detection.svg") as string
const maskDetection = require("../../images/icons-function/emotion-prediction.svg") as string
const handGesture = require("../../images/icons-function/hand-gesture-recognition.svg") as string
const gazeEstimation = require("../../images/icons-function/gaze-estimation.svg") as string

const FunctionCortexBlock: React.SFC<FunctionCortexBlockProps> = () => {
  const [dataFunction, setDatFunction] = useState([
    {
      title: "Person Detection",
      icon: personDetection,
      section: "Human Detection",
      description: "Detects people and their locations in the image",
      animation: "slide-up",
      target: "#persondetection",
    },
    {
      title: "Person Tracking",
      icon: personTracking,
      section: "Track the same person",
      description: "Track the same person across multiple frames and multiple people",
      animation: "slide-up",
      target: "#persontracking",
    },
    {
      title: "Face Detection",
      icon: faceDetection,
      section: "Face Detection",
      description: "Detects the face and position of a person in an image",
      animation: "slide-up",
      target: "#facedetection",
    },
    {
      title: "Attention Detection",
      icon: attentionDetection,
      section: "Gaze Detection",
      description: "Detects a person's gaze and recognizes whether the person is gazing or not",
      animation: "slide-up",
      target: "#attentiondetection",
    },
    {
      title: "Emotion Prediction",
      icon: maskDetection,
      section: "Emotion Estimation",
      description: "Estimates emotions from detected human facial expressions",
      animation: "slide-up",
      target: "#emotionprediction",
    },
    {
      title: "Mask Detection",
      icon: emotionPrediction,
      section: "Detects whether or not a mask is worn",
      description: "Detects whether or not someone has a mask on",
      animation: "slide-up",
      target: "#maskdetection",
    },
    {
      title: "Gaze Estimation",
      icon: gazeEstimation,
      section: "Detecting the direction of a person's gaze",
      description: "Detects the direction of a person's gaze",
      animation: "slide-up",
      target: "",
    },
  ])
  return (
    <div className="container-full block-function">
      <h3 className="u-text-center subtitle-section">Functions</h3>
      <div className="container block-function__list-section">
        <ul className="block-function__list" style={{ listStyle: "disc" }}>
          <li>Detects and identifies human information on images in detail</li>
          <li>
            Lightweight, stand-alone AI for fast recognition speed and high
            security
          </li>
          <li>
            Runs on an inexpensive system (Jetson Nano™ + off-the-shelf camera)
          </li>
        </ul>
      </div>
      <div className="container block-function__card-section">
        <div className="row">
          {dataFunction.map((item, i) => (
            <div
              key={i}
              className="col-lg-4 col-md-6 col-sm-12 u-padding-20 u-padding-left-2
            u-padding-right-2 card-main"
            >
              {item.target === "" ? (
                <div className="card-content card-content-no-link">
                  <h4 className="u-text-center">{item.title}</h4>
                  <img src={item.icon} alt="" />
                  {/* <h5 className="u-text-center u-text-bold">{item.section}</h5> */}
                  <p className="u-text-center">{item.description}</p>
                </div>
              ) : (
                <div
                  className="card-content"
                  onClick={() => scrollTo(item.target)}
                >
                  <h4 className="u-text-center">{item.title}</h4>
                  <img src={item.icon} alt="" />
                  {/* <h5 className="u-text-center u-text-bold">{item.section}</h5> */}
                  <p className="u-text-center">{item.description}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default FunctionCortexBlock
